import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useM } from "./useM";

const Col = ({ title, links }) => (
  <div>
    <p className="font-mono-t text-xs uppercase tracking-[0.2em] text-white/40">{title}</p>
    <ul className="mt-5 space-y-3">
      {links.map(([to, label, id]) => (
        <li key={to}><Link to={to} className="text-sm text-white/70 transition-colors hover:text-mk-yellow" data-testid={`footer-link-${id}`}>{label}</Link></li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const m = useM();
  const { pathname } = useLocation();
  const brandCls = "flex items-center gap-2.5 font-heading text-2xl font-extrabold text-white";
  const brand = <><Logo size={24} className="text-mk-yellow" /> KIHAP</>;
  return (
    <footer className="border-t border-white/10 bg-mk-bg" data-testid="public-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-[2fr_1fr_1fr] lg:px-10">
        <div>
          {pathname === "/" ? <div className={`${brandCls} cursor-default select-none`} data-testid="footer-brand">{brand}</div> : <Link to="/" className={brandCls} data-testid="footer-link-home">{brand}</Link>}
          <p className="mt-4 whitespace-nowrap text-xs uppercase tracking-[0.25em] text-mk-muted" data-testid="footer-subtitle">Tournament Software for Taekwondo</p>
        </div>
        <Col title={m("footer.product")} links={[["/features", m("nav.features"), "features"], ["/how-it-works", m("nav.how"), "how"], ["/about", m("nav.about"), "about"]]} />
        <Col title={m("footer.account")} links={[["/login", m("nav.login"), "login"], ["/register", m("footer.register"), "register"], ["/ring-login", m("footer.ring"), "ring"]]} />
      </div>
      <div className="mx-auto max-w-7xl border-t border-white/5 px-6 py-6 text-xs text-white/30 lg:px-10">
        © {new Date().getFullYear()} KIHAP. {m("footer.rights")}
      </div>
    </footer>
  );
};
